import React from 'react';

import MergetagInputForm from '@Components/formsy/MergetagInput'
import GlobalInput from 'components/form/Input';

function InputMergeTag({ mergetags, ...props }) {
  return <MergetagInputForm
    {...props}
    mergetags={mergetags.filter(Boolean).map(([key]) => key)}
    validations={{
      mergeTagValid: (_, value) => !/[{}]/.test(value.replace(/{(\w+)}/g, ($1, $2) => mergetags.find(d => d && d[0] === $2) ? '' : $1)),
    }}
    validationErrors={{
      mergeTagValid: 'Merge Tags invalid',
    }}
  />
}

function Input({ onChange, ...props }) {
  const handleChange = evt => {
    onChange && onChange(evt.target.value)
  }
  return <GlobalInput {...props} onChange={handleChange} />
}

export {
  Input,
  InputMergeTag,
}
